module.exports = __webpack_public_path__ + "static/media/Q2-6.096e32b7.JPG";